import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { Component, DestroyRef, Input, OnChanges, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';

import { DeviceService, TrackingService, UserService } from '@frontend/vanilla/core';
import { SwiperComponent } from '@frontend/vanilla/shared/swiper';
import { Subscription } from 'rxjs';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { InstagramPromoImageComponent } from '../instagram-promo-image/instagram-promo-image.component';
import { InstagramStoryModalComponent } from '../instagram-story-modal/instagram-story-modal.component';
import { InstaPromoLocalStorageModel } from '../shared/model/insta-promo-local-storage.model';
import { InstaPromoModel } from '../shared/model/insta-promo.model';
import { StoryModel } from '../shared/model/story.model';
import { UserActionService } from '../shared/services/user-action.service';

@Component({
    selector: 'cc-instagram-story-container',
    templateUrl: 'instagram-story-container.component.html',
    imports: [NgStyle, NgClass, SwiperComponent, NgFor, NgIf, InstagramPromoImageComponent],
})
export class InstagramStoryContainerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() storyData: StoryModel;
    @Input() config: any;
    storyIconShape: string;
    viewedPromotionBrClr: string;
    notviewedPromotionBrClr: string;
    themeCheckClr: string;
    themeCheckBgClr: string;
    promotionTxtClr: string;
    promotionsBgClr: string;
    viewedpromotionTxtClr: string;
    changePromoStatusObservable: Subscription;
    trackViewedStateForPostLogin: boolean;
    trackViewedStateForPreLogin: boolean;
    enableOverlayMobileSearchTopPosition: boolean;
    gamingstoriesExpirationTimeInterval: number = 10;
    showStoryViewedTickMark: boolean;
    moveSlideTo: number;
    isTouch: boolean;
    private destroyRef = inject(DestroyRef);

    swiperOptions: SwiperOptions = {
        speed: 500,
        autoHeight: true,
        spaceBetween: 5,
        slidesPerGroup: 3,
        preventClicks: false,
        preventClicksPropagation: false,
    };

    constructor(
        private dialog: MatDialog,
        private userActionService: UserActionService,
        private tracking: TrackingService,
        private user: UserService,
        private deviceService: DeviceService,
    ) {}

    ngOnInit() {
        this.renderGamingStoriesPromo();
        this.isTouch = this.deviceService.isTouch;
        if (this.isTouch) {
            this.swiperOptions.navigation = false;
            this.swiperOptions.allowTouchMove = true;
            this.swiperOptions.slidesPerView = 4.7;
        } else {
            this.swiperOptions.allowTouchMove = false;
            this.swiperOptions.slidesPerView = 5;
            this.swiperOptions.navigation = true;
        }
    }

    ngOnChanges() {
        this.renderGamingStoriesPromo();
    }

    renderGamingStoriesPromo() {
        if (this.config) {
            this.trackViewedStateForPostLogin = this.config.trackViewedStateForPostLogin ? this.config.trackViewedStateForPostLogin : false;
            this.trackViewedStateForPreLogin = this.config.trackViewedStateForPreLogin ? this.config.trackViewedStateForPreLogin : false;
            this.gamingstoriesExpirationTimeInterval = this.config.gamingstoriesExpirationTimeInterval
                ? this.config.gamingstoriesExpirationTimeInterval
                : 10;
            this.showStoryViewedTickMark = this.config.showStoryViewedTickMark ? this.config.showStoryViewedTickMark : false;
        }
        this.storyIconShape = this.storyData.storyIconShape ? this.storyData.storyIconShape : 'circle';
        this.viewedPromotionBrClr = this.storyData.sharedList.viewedPromotionBrClr;
        this.notviewedPromotionBrClr = this.storyData.sharedList.notviewedPromotionBrClr;
        this.themeCheckClr = this.storyData.sharedList.themeCheckClr;
        this.themeCheckBgClr = this.storyData.sharedList.themeCheckBgClr;
        this.viewedpromotionTxtClr = this.storyData.sharedList.viewedpromotionTxtClr;
        this.promotionTxtClr = this.storyData.sharedList.promotionTxtClr;
        this.promotionsBgClr = this.storyData.sharedList.promotionsBgClr;
        if ((this.user.isAuthenticated && this.trackViewedStateForPostLogin) || (!this.user.isAuthenticated && this.trackViewedStateForPreLogin)) {
            this.filterStories(); //Function to track view state of promo using array stored in local storage
        }
        this.changePromoStatusObservable = this.userActionService.changePromoStatusObservable
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((promoStatusObject: any) => {
                if (promoStatusObject) {
                    this.storyData.instaPromoList[promoStatusObject.activePromoIndex].instaStoryContentModel[
                        promoStatusObject.activePromoStoryIndex
                    ].targetPromoStatus = promoStatusObject.promoStatus;
                }
            });
    }

    openStoryDialog(index: number) {
        const dialogData = {
            storyData: this.storyData,
            activePromoIndex: index,
            enableOverlayMobileSearchTopPosition: this.config.enableOverlayMobileSearchTopPosition
                ? this.config.enableOverlayMobileSearchTopPosition
                : false,
        };
        this.trackGamingStories(index);
        const dialogRef = this.dialog.open(InstagramStoryModalComponent, {
            width: '375px',
            data: dialogData,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((storyData: StoryModel) => {
                this.userActionService.pauseVideo();
                document.getElementsByTagName('html')[0].classList.remove('casino-mobile-stories');
                if (storyData) {
                    const viewedInstaPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
                    const notViewedInstaPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
                    storyData.instaPromoList.forEach((promo: InstaPromoModel) => {
                        if (promo.viewed) {
                            viewedInstaPromoList.push(promo);
                        } else {
                            notViewedInstaPromoList.push(promo);
                        }
                    });
                    if (
                        (this.user.isAuthenticated && this.trackViewedStateForPostLogin) ||
                        (!this.user.isAuthenticated && this.trackViewedStateForPreLogin)
                    ) {
                        this.storeStoriesViewedStateInLocalStorage(viewedInstaPromoList);
                        this.filterStories();
                    } else {
                        this.userActionService.instaPromoList = notViewedInstaPromoList.concat(viewedInstaPromoList.reverse()); //Updating promo view state without storing in local storage
                        this.storyData.instaPromoList = this.userActionService.instaPromoList;
                    }
                } else {
                    this.sortingViewedAndUnviewed(this.storyData.instaPromoList);
                }
            });
        document.getElementsByTagName('html')[0].classList.add('casino-mobile-stories');
    }

    sortingViewedAndUnviewed(storyList: Array<InstaPromoModel>) {
        const viewedGamingPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
        const notViewedGamingPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
        storyList.forEach((promo: InstaPromoModel) => {
            if (promo.viewed) {
                viewedGamingPromoList.push(promo);
            } else {
                notViewedGamingPromoList.push(promo);
            }
        });
        this.storyData.instaPromoList = notViewedGamingPromoList.concat(viewedGamingPromoList.reverse());
    }

    trackGamingStories(index: number) {
        this.tracking.triggerEvent('Event.Tracking', {
            'component.CategoryEvent': 'teaser - embedded video',
            'component.LabelEvent': 'stories',
            'component.ActionEvent': 'click',
            'component.PositionEvent': index + 1,
            'component.LocationEvent': this.storyData.instaPromoList[index].promoItemId,
            'component.EventDetails': 'story icon',
            'component.URLClicked': 'not applicable',
        });
    }

    filterStories() {
        const instaPromoArrayFromLocalStorage = this.userActionService.readGamingStoriesArray();
        if (instaPromoArrayFromLocalStorage) {
            let viewedInstaPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
            const notViewedInstaPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
            let instaPromoLocalStorageArray: Array<InstaPromoLocalStorageModel> = new Array<InstaPromoLocalStorageModel>();
            this.storyData.instaPromoList.forEach((promo: InstaPromoModel) => {
                let isViewedPromo: boolean = false;
                let promoItem: InstaPromoLocalStorageModel;
                for (let i = 0; i < instaPromoArrayFromLocalStorage.length; i++) {
                    promoItem = instaPromoArrayFromLocalStorage[i];
                    if (promo.promoItemId == promoItem.promoItemId) {
                        if (this.checkPromoExpiration(promoItem.viewedTimeStamp)) {
                            isViewedPromo = true;
                            promo.viewed = true;
                            viewedInstaPromoList[i] = promo;
                            instaPromoLocalStorageArray[i] = promoItem;
                            break;
                        }
                    }
                }
                if (!isViewedPromo) {
                    notViewedInstaPromoList.push(promo);
                }
            });
            viewedInstaPromoList = viewedInstaPromoList.filter((promo) => promo !== undefined);
            instaPromoLocalStorageArray = instaPromoLocalStorageArray.filter((promoItem) => promoItem !== undefined);
            this.storyData.instaPromoList = notViewedInstaPromoList.concat(viewedInstaPromoList);
            this.userActionService.writeGamingStoriesArray(instaPromoLocalStorageArray); //Updating local storage array
        }
    }

    storeStoriesViewedStateInLocalStorage(viewedInstaPromoList: InstaPromoModel[]) {
        const instaPromoArrayFromLocalStorage = this.userActionService.readGamingStoriesArray();
        let instaPromoLocalStorageArray: Array<InstaPromoLocalStorageModel> = instaPromoArrayFromLocalStorage
            ? instaPromoArrayFromLocalStorage
            : new Array<InstaPromoLocalStorageModel>();
        viewedInstaPromoList.forEach((promo: InstaPromoModel) => {
            if (instaPromoArrayFromLocalStorage) {
                let promoAlreadyInLocalStorageArray: boolean = false;
                for (let i = 0; i < instaPromoArrayFromLocalStorage.length; i++) {
                    if (promo.promoItemId == instaPromoArrayFromLocalStorage[i].promoItemId) {
                        promoAlreadyInLocalStorageArray = true;
                        break;
                    }
                }
                if (!promoAlreadyInLocalStorageArray) {
                    instaPromoLocalStorageArray = this.pushPromoItemToArray(instaPromoLocalStorageArray, promo.promoItemId);
                }
            } else {
                instaPromoLocalStorageArray = this.pushPromoItemToArray(instaPromoLocalStorageArray, promo.promoItemId);
            }
        });
        if (instaPromoLocalStorageArray.length > 0) {
            this.userActionService.writeGamingStoriesArray(instaPromoLocalStorageArray);
        }
    }

    pushPromoItemToArray(instaPromoLocalStorageArray: InstaPromoLocalStorageModel[], promoItemId: string) {
        const localStoragePromoItem: InstaPromoLocalStorageModel = new InstaPromoLocalStorageModel();
        localStoragePromoItem.promoItemId = promoItemId;
        localStoragePromoItem.viewedTimeStamp = new Date().getTime();
        instaPromoLocalStorageArray.push(localStoragePromoItem);
        return instaPromoLocalStorageArray;
    }

    checkPromoExpiration(promoTimeStamp: number) {
        //Function to check if local storage has expired for a particular promo
        const expirationTimeStamp = this.gamingstoriesExpirationTimeInterval * 24 * 60 * 60 * 1000; //Converting days to milliseconds
        return new Date().getTime() - promoTimeStamp < expirationTimeStamp;
    }

    ngOnDestroy() {
        if (this.changePromoStatusObservable) {
            this.changePromoStatusObservable.unsubscribe();
        }
    }
}
